import {IMyCoupons} from "../interfaces";
import {cloneDeep} from "lodash";

export default class DataHelper{


    static GroupAndSortCouponsList(dataList:IMyCoupons[]) {
        const _dataList = cloneDeep(dataList);
        //_dataList.sort((a:IMyCoupons,b:IMyCoupons) => a.couponCode - b.couponCode);
        let grouped = this.groupBy(_dataList, (p:IMyCoupons) => p.couponCode);
        let groupedArr = new Array(...grouped);
        return groupedArr;
    }
    static GroupAndSortDataList(dataList:IMyCoupons[]) {
        const _dataList = cloneDeep(dataList);
        _dataList.sort((a:IMyCoupons,b:IMyCoupons) => a.campaignID - b.campaignID);
        let grouped = this.groupBy(_dataList, (p:IMyCoupons) => p.campaignID);
        let groupedArr = new Array(...grouped);
        return groupedArr;
    }
    static groupBy(list :any, keyGetter:any) {
        const map = new Map();
        list.forEach((item: any) => {
            const key = keyGetter(item);

            const collection = map.get(key);
            if (!collection) {
                //console.log('item: ',item);
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }




}

